<ng-container [formGroup]="formData">
  <textarea
    pInputTextarea
    [rows]="rows"
    appMuAutosize
    [id]="controlName"
    [name]="controlName"
    [formControlName]="controlName"
    [placeholder]="'form.placeholder.' + controlName | translate"
    [maxlength]="maxLength"
    [ngClass]="{ 'mu-form-editable-mask': editableMask }"
    (click)="editableMask = false"
    (blur)="validatorService?.validateControl(formData, controlName, changeDetectorRef)"
  ></textarea>
</ng-container>
